import { authedJson } from '../api/client';

export interface Label {
  labelId: string;
  workspaceId: string;
  name: string;
  color: string;
  createdBy: string;
  createdAt: number;
  updatedAt: number;
}

type GetToken = () => string | null;
type DoRefresh = () => Promise<boolean>;

export const labelsApi = {
  list: (workspaceId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<{ labels: Label[] }>(`/workspaces/${workspaceId}/labels`, { method: 'GET' }, getToken, doRefresh),

  create: (workspaceId: string, name: string, color: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<Label>(
      `/workspaces/${workspaceId}/labels`,
      { method: 'POST', body: JSON.stringify({ name, color }) },
      getToken,
      doRefresh,
    ),

  update: (
    workspaceId: string,
    labelId: string,
    updates: Partial<Pick<Label, 'name' | 'color'>>,
    getToken: GetToken,
    doRefresh: DoRefresh,
  ) =>
    authedJson<Label>(
      `/workspaces/${workspaceId}/labels/${labelId}`,
      { method: 'PUT', body: JSON.stringify(updates) },
      getToken,
      doRefresh,
    ),

  remove: (workspaceId: string, labelId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<void>(`/workspaces/${workspaceId}/labels/${labelId}`, { method: 'DELETE' }, getToken, doRefresh),
};
